import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Guardian } from '@xaamin/guardian';
import { Spinner, Col, Row, Dropdown, Button, ButtonGroup } from 'react-bootstrap';

import useGlobal from '../../store';
import UsuarioInfo from './info/UsuarioInfo';
import Loading from '../../facturotopia/loading/Loading';
import PageHeader from '../../support/page-header/PageHeader';

const UsuariosInfo = (props) => {
  const [state, actions] = useGlobal(mapState, mapActions);

  const { data: _dataRouting = {}} = props.location.state || {};

  const { id } = props.match.params;

  const dataRouting = !!_dataRouting.id ? { ..._dataRouting } : { id }

  useEffect(() => {
    actions.change(dataRouting);

    if (!!dataRouting.nombre) {
      return;
    }

    actions.info(dataRouting.id);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    const cleanup = () => {
      actions.change({});
    }

    return cleanup;
  }, []); // eslint-disable-line

  const { data = {}, busy } = state;

  const edit = {
    pathname: `/app/usuarios/${dataRouting.id}/editar`,
    state: {
      data: { ...data }
    }
  }

  const permisos = {
    pathname: `/app/usuarios/${dataRouting.id}/permisos`,
    state: {
      data: { ...data }
    }
  }

  if (!!busy) {
    return <Loading className="text-info" />;
  }

  const renderItemAction = () => {
    return (
      <Dropdown as={ ButtonGroup } alignRight={ true }>
        { Guardian.allows('usuario.editar.informacion') && (
          <Link to={ edit }>
            <Button type="button" variant="secondary">
              Editar { ' ' }
            </Button>
          </Link>
        )}

        <Dropdown.Toggle split variant="secondary" id="dropdown-split-basic" />

        <Dropdown.Menu>
          { Guardian.allows('usuario.editar.permisos') && (
            <Dropdown.Item as={ Link } to={ permisos }>
              Editar permisos
            </Dropdown.Item>
          )}
        </Dropdown.Menu>
      </Dropdown>
    )
  }

  return (
    <>
      <PageHeader text="Usuarios" to="/app/usuarios" />

      <Row>
        <Col>
          { !!busy && (
            <Spinner animation="border" role="status" size="sm" className="mr-3">
              <span className="sr-only">Loading usuario info...</span>
            </Spinner>
            )
          }
          { data.nombre || '...' }
        </Col>

        <Col className='text-right'>
          { renderItemAction() }
        </Col>
      </Row>

      <Row>
        <Col>
            <UsuarioInfo data={ data } />
        </Col>
      </Row>

      { !!data.nombre && (
        <div className="d-block mt-3 mb-2">
          <strong className="text-muted">Actividad</strong>
        </div>
      )}
    </>
  );
}

const mapState = (state) => {
  return state.app.usuarios.info;
};

const mapActions = (actions) => {
  return actions.app.usuarios.info;
};

export default UsuariosInfo;